var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulletList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57185 2.56693C6.57185 2.95333 6.88467 3.26693 7.2701 3.26693H16.1146C16.5003 3.26693 16.8129 2.95353 16.8129 2.56693C16.8129 2.18033 16.5003 1.86693 16.1146 1.86693H7.2701C6.88447 1.86693 6.57185 2.18033 6.57185 2.56693ZM0.98584 2.56693C0.98584 1.66533 1.70923 0.933594 2.61509 0.933594C3.51444 0.933594 4.24435 1.65879 4.24435 2.56693C4.24435 3.46853 3.52096 4.20026 2.61509 4.20026C1.71575 4.20026 0.98584 3.47506 0.98584 2.56693ZM6.57185 10.9669C6.57185 11.3533 6.88467 11.6669 7.2701 11.6669H16.1146C16.5003 11.6669 16.8129 11.3535 16.8129 10.9669C16.8129 10.5803 16.5003 10.2669 16.1146 10.2669H7.2701C6.88447 10.2669 6.57185 10.5803 6.57185 10.9669ZM0.98584 10.9669C0.98584 10.0653 1.70923 9.33359 2.61509 9.33359C3.51444 9.33359 4.24435 10.0588 4.24435 10.9669C4.24435 11.8685 3.52096 12.6003 2.61509 12.6003C1.71575 12.6003 0.98584 11.8751 0.98584 10.9669Z",
    fill: "#31393C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletList);
export default ForwardRef;